import { useState, useEffect } from "react";
import "./App.css";
import Header from "./containers/Header";
import SongsContainer from "./containers/SongsContainer";
import Filters from "./containers/Filters";
import { MenuContext } from "./contexts/MenuContext";
import SongDisplay from "./components/SongDisplay";

function App() {
  const [openSong, setOpenSong] = useState([]);
  const [order, setOrder] = useState("ASC");
  const [expanded, setExpanded] = useState(false);
  const [selectedSongs, setSelectedSongs] = useState([]);
  const [checked, setChecked] = useState([]);
  const [data, setData] = useState([]);
  const [menu, setMenu] = useState("closed");
  const [selector, setSelector] = useState(false);
  const [saved, setSaved] = useState(false);

  // const getData = () => {
  //   fetch("song.json", {
  //     headers: {
  //       "Content-Type": "application/json",
  //       Accept: "application/json",
  //     },
  //   })
  //     .then(function (response) {
  //       // console.log(response);
  //       return response.json();
  //     })
  //     .then(function (myJson) {
  //       // console.log(myJson);
  //       setData(myJson);
  //     });
  // };
  /////// USING ASYNC/AWAIT //////////////////////
  const getData = async () => {
    try {
      const initData = await fetch("song.json", {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      });
      const jsonData = await initData.json();
      setData(jsonData);
    } catch (error) {
      console.log(error);
      setData([]);
    }
  };
  /////////////////////////////////////////////
  useEffect(() => {
    getData();
  }, []);

  return (
    <div className="App">
      <MenuContext.Provider
        value={{
          saved,
          setSaved,
          selector,
          setSelector,
          setMenu,
          data,
          setData,
          checked,
          setChecked,
          expanded,
          setExpanded,
          selectedSongs,
          setSelectedSongs,
          order,
          setOrder,
          openSong,
          setOpenSong,
        }}
      >
        {/* The end of MenuContext.Provider */}

        {(openSong.length > 0 && <SongDisplay />) ||
          (menu === "closed" && (
            <>
              <Header />
              <SongsContainer />
            </>
          ))}

        {/* If Menu filter is opened */}
        {menu === "opened" && <Filters />}
      </MenuContext.Provider>
    </div>
  );
}

export default App;
